module.exports = __webpack_public_path__ + "static/img-onboarding-6d78610391526f0f650652540ef36e92.png";